import _ from 'lodash';
import Immutable from 'seamless-immutable';

import RefData from 'ref-data';

import { assetRefService } from '../../common/Services';

const getMutable = (data, opts = {}) => (Immutable.isImmutable(data) ? data.asMutable(opts) : data);

/**
 * Page
 * @typedef {Object} PageTemplate
 *
 * @property {string} caption descriptive caption text
 * @property {string} classRef refdata class
 * @property {string} id database identifier
 * @property {string} name template name
 * @property {bool} shared is this a shared template?
 * @property {string} thumbnail path to thumbnail image
 * @property {string} title main display title
 * @property {string} typeRef refdata typeRef type.displayobject.page
 * @property {string} validFor types of experiences this page template is valid for
 */

/**
 * Create a PageTemplateModel from provided data
 */
function create(pageTemplate = {}) {
  const result = _.clone(pageTemplate);

  result.typeRef = _.isString(pageTemplate.typeRef)
    ? RefData.Model.hydrate(pageTemplate.typeRef)
    : pageTemplate.typeRef;
  result.classRef = _.isString(pageTemplate.classRef)
    ? RefData.Model.hydrate(pageTemplate.classRef)
    : pageTemplate.classRef;

  return Immutable(result, { prototype: model });
}

/**
 * Transforms a backend page template object into a frontend PageTemplate Model
 * @param {Object} pageTemplate - backend formatted page template
 * @returns {PageTemplate}
 */
function deserialize(pageTemplate) {
  const result = _.pick(pageTemplate, _keys);

  return create(result);
}

/**
 * Transform a PageTemplateModel into a backend page object
 * @returns {Object}
 */
function serialize(pageTemplate) {
  const result = getMutable(pageTemplate, { deep: true });

  if (result.typeRef) result.typeRef = pageTemplate.typeRef.id;
  if (result.classRef) result.classRef = pageTemplate.classRef.id;

  return _.pick(result, _keys);
}

/** The PageTemplateModel prototype */
const model = {
  get assetRef() {
    return assetRefService.buildAssetRef('static', 'image', 'auto', this.thumbnail);
  },
};

/**
 * An array of keys on the API Theme object that should be shared between the API requests and responses
 */
const _keys = ['caption', 'classRef', 'id', 'name', 'shared', 'thumbnail', 'title', 'typeRef', 'validFor'];

export default {
  create,
  deserialize,
  serialize,
};
